import '../assets/header.css';
import { jsxs as m, jsx as e } from "react/jsx-runtime";
import { Button as o } from "@datamole/wds-component-button";
import { faXmark as i } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon as d } from "@fortawesome/react-fontawesome";
import { Title as h, Close as f } from "@radix-ui/react-dialog";
import p from "clsx";
import { forwardRef as _ } from "react";
const u = "_header_sd5ev_3", x = "_close_button_sd5ev_19", r = {
  header: u,
  close_button: x
}, b = _((t, s) => {
  const { className: n, children: a, closeIcon: c, ...l } = t;
  return /* @__PURE__ */ m(h, { ...l, ref: s, className: p(r.header, n), children: [
    a,
    /* @__PURE__ */ e(f, { asChild: !0, children: /* @__PURE__ */ e(o, { variant: "text", size: "md", className: r.close_button, children: /* @__PURE__ */ e(o.Icon, { children: c ?? /* @__PURE__ */ e(d, { icon: i }) }) }) })
  ] });
});
b.displayName = "Dialog.Content.Header";
export {
  b as DialogContentHeader
};
